import React, { Component } from 'react';
import { Link } from 'react-router'

export default class ForumNameNotifier extends Component {
  render() {
    if (this.props.forumName === 'Anonymous better' || !this.props.forumName) {
      return (
        <div className='alert alert-dismissable forum-name-notifier'>
          <button type='button' className='close' data-dismiss='alert'>&times;</button>
          <p>Let others know who you are and select your own display name on your <Link to='/me'>profile page</Link></p>
        </div>
      )
    }
    return <div />;
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/ForumNameNotifier.js
 **/